function getStatusClass(status: string): string {
  if (["accepted"].includes(status)) return "text-green-600";
  if (["requested"].includes(status)) return "text-purple-600";
  if (["in_progress", "draft"].includes(status)) return "text-blue-600";
  if (
    ["cancelled", "completed", "expired", "deleted", "archived"].includes(
      status,
    )
  )
    return "text-gray-600";
  if (["pending"].includes(status)) return "text-orange-600";
  if (status === "rejected") return "text-red-600";
  return "text-yellow-600";
}

const getTranslate = (status: string) => {
  switch (status.toLowerCase()) {
    case "requested":
      return "Solicitado pelo cliente";
    case "in_progress":
    case "draft":
      return "Em progresso";
    case "sent":
      return "Enviado para o cliente";
    case "expired":
      return "Expirado";
    case "cancelled":
      return "Cancelado";
    case "accepted":
      return "Aceite pelo cliente";
    case "pending":
      return "Encomenda - Pendente";
    case "confirmed":
      return "Encomenda - Confirmada";
    case "rejected":
      return "Encomenda - Rejeitada";
    case "shipped":
      return "Encomenda - Enviada";
    case "completed":
      return "Concluído";
    case "archived":
      return "Arquivado";
    default:
      return status;
  }
};

export { getStatusClass, getTranslate };
